<template>
  <aside class="gept-sidenav gept_main_bg">
    <ul class="sidenav__list list-unstyled m-0 p-0 font-semibold">
      <li
        class="sidenav__list_item d-xl-none"
        :class="{ active: $route.name === 'AI_Home' }"
      >
        <!-- <router-link
          @click.native="$emit('closeMenu')"
          :to="{ name: 'AI_Home' }"
          class="d-flex align-items-center p-3 text-decoration-none"
        >
          <img
            class="img-fluid mr-2 hover_off"
            src="@/assets/image/gept/list_logo2.png"
            alt=""
          />
          <img
            class="img-fluid mr-2 hover_on"
            src="@/assets/image/gept/list_logo.png"
            alt=""
          />
          <span class="h5 mb-0 font-semibold">AI學習首頁</span>
        </router-link> -->
      </li>

      <!-- practice overview -->
      <li
        class="sidenav__list_item"
        :class="{ 'active': $route.name === 'GEPT_Overview' || $route.name ==='quiz_Overview' }"
      >
        <router-link @click="$emit('closeMenu')" :to="{ name: this.$route.path.includes('quiz') ? 'quiz_Overview' : 'GEPT_Overview' }"
          class="d-flex align-items-center p-3 text-decoration-none"
        >
          <img
            class="img-fluid mr-2 hover_off"
            src="@/assets/image/gept/list_logo2.png"
            alt=""
          />
          <img
            class="img-fluid mr-2 hover_on"
            src="@/assets/image/gept/list_logo.png"
            alt=""
          />
          <span class="h5 mb-0 font-semibold">{{ $t('GEPT.common.practiceOverview') }}</span>
    </router-link>
      </li>

      <!-- logout（mobile only） -->
      <li class="p-3 d-xl-none">
        <a
          class="btn btn-sm btn-block bg-red-main-ai text-white"
          @click.prevent="logout2()"
        >
          {{ $t('GEPT.common.logout') }}
        </a>
      </li>

    </ul>
  </aside>
</template>
<script>
import { mapGetters } from 'vuex'
  export default {
    name: 'Sidebar',

    data () {
      return {
      }
    },
    props: {
    },
    computed: {
      ...mapGetters([
        'authorized',
        'remainPoints',
        'level'
      ])
    },
    watch: {
    },
    mounted () {
    },
    methods: {
      logout2 () {
        this.$store.dispatch('logout')
        this.$router.replace({ name: 'login' })
      }
    }
  }
</script>

<style lang="scss" scoped>
.gept-sidenav {
  width: 100%;
  @media (min-width: 1201px) {
    max-width: 200px;
  }
  .sidenav__list {
    .sidenav__list_item {
      color: #4496C2 !important;
      .hover_on {
        display: none;
      }
      &:hover {
        background: #91D3F6;
        color: #073E5C;
        .hover_on {
          display: block;
        }
        .hover_off {
          display: none !important;
        }
      }
    }
    .active {
      background: #91D3F6;
      color: #073E5C !important;
      .hover_on {
        display: block;
      }
      .hover_off {
        display: none !important;
      }
    }
  }
}
</style>
